<div class="carousel-container">
	<div class="buttons-container">
		<button
			(click)="onPreviousClick()"
			class="previous-button bpi__icon-caret-left"
			[ngClass]="{ 'show-button': index > 0 }"></button>
		<button
			(click)="onNextClick()"
			class="next-button bpi__icon-caret-right"
			[ngClass]="{ 'hide-button': hideNextButton }"></button>
	</div>
	<div class="slider-content" #carouselContainer>
		<ng-content></ng-content>
	</div>
</div>
